import { render, staticRenderFns } from "./Vendeurs.vue?vue&type=template&id=21bd5928&scoped=true&"
import script from "./Vendeurs.vue?vue&type=script&lang=js&"
export * from "./Vendeurs.vue?vue&type=script&lang=js&"
import style0 from "./Vendeurs.vue?vue&type=style&index=0&id=21bd5928&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bd5928",
  null
  
)

export default component.exports